/**
 * Scroll to an in-article help heading, offset for sticky app chrome.
 * @param {string} id
 */
export function scrollToHelpHeading(id) {
  if (!id) return;
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
